import ConfirmationDialog from './confirmation';

export { ConfirmationDialog };



// WEBPACK FOOTER //
// ./src/components/dialogs/index.js